import { Refinement } from "@siteimprove/alfa-refinement";
const { isFunction, isObject } = Refinement;
/**
 * @public
 */
export var Hashable;
(function (Hashable) {
    function isHashable(value) {
        return isObject(value) && isFunction(value.hash);
    }
    Hashable.isHashable = isHashable;
})(Hashable || (Hashable = {}));
//# sourceMappingURL=hashable.js.map